import { DigitalProductJourneyLevelsChallengesInitial as Challenge } from '.'

export const SLUG = 'initial'
export const challenge = {
  SLUG,
  customContent: true,
  Component: Challenge
}
